import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=6834245f&scoped=true&"
import script from "./TagsSelector.vue?vue&type=script&lang=js&"
export * from "./TagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelector.vue?vue&type=style&index=0&id=6834245f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834245f",
  null
  
)

/* custom blocks */
import block0 from "./TagsSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "TagsSelector.vue"
export default component.exports